import AddPublication from './add-publication';

export default AddPublication;